<div class="product-ad-inventory-health">
  <div class="inv-chart-container">
    <div class="inv-bar-row">
      <!-- OOS marker (dot outside the bar) -->
      <ng-template #oosTooltip>
        <div>
          <div><strong>{{ statusDisplay['OUT_OF_STOCK']?.header }}</strong></div>
          <div class="text-sm">{{ statusDisplay['OUT_OF_STOCK']?.range }}</div>
          <hr class="ml-4 mr-4" />
          <p class="text-left">
            <strong class="text-primary">Description:</strong>
            {{ statusDisplay['OUT_OF_STOCK']?.body }}
          </p>
          <hr class="ml-4 mr-4" />
          <div class="text-left">
            <strong class="text-primary">Action:</strong>
            {{ statusDisplay['OUT_OF_STOCK']?.action }}
          </div>
        </div>
      </ng-template>

      <div
        class="oos-marker"
        [class.active]="currentStatusKey === 'OUT_OF_STOCK'"
        [ngbTooltip]="oosTooltip"
        tooltipClass="inventory-health-tooltip"
      >
        <i class="fas fa-exclamation-triangle"></i>
      </div>

      <!-- Bar + indicator -->
      <div class="inv-bar-wrapper">
        <div class="inv-bar">
          <ng-container *ngFor="let segment of statusSegments">
            <ng-template #unifiedTooltip>
              <div *ngIf="statusDisplay[segment.state] as t">
                <div><strong>{{ t.header }}</strong></div>
                <div class="text-sm">{{ t.range }}</div>
                <hr class="ml-4 mr-4" />
                <p class="text-left">
                  <strong class="text-primary">Description:</strong>
                  {{ t.body }}
                </p>
                <hr class="ml-4 mr-4" />
                <div class="text-left">
                  <strong class="text-primary">Action:</strong>
                  {{ t.action }}
                </div>
              </div>
            </ng-template>

            <div
              class="inv-seg"
              [class.active]="segment.state === currentStatusKey"
              [ngClass]="segment.class"
              [ngbTooltip]="unifiedTooltip"
              tooltipClass="inventory-health-tooltip"
              [style.flex]="segmentFlex[segment.state]"
            >
              <span>{{ statusDisplay[segment.state]?.shortHeader || statusDisplay[segment.state]?.header }}</span>
            </div>
          </ng-container>
        </div>

        <div class="inv-indicator" *ngIf="daysUntilStockOut > 0" [style.left]="indicatorLeft">
          <div class="ind-tag" [ngClass]="riskClass">{{ daysUntilStockOut }}</div>
          <div class="ind-arrow" [ngClass]="riskClass"></div>
          <div class="ind-line"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="inv-labels">
    <div class="oos-label-spacer">
      <span class="segment-range-label">0</span>
    </div>
    <ng-container *ngFor="let segment of statusSegments">
      <div class="inv-label-item" [style.flex]="segmentFlex[segment.state]">
        <span class="segment-range-label">{{ statusDisplay[segment.state]?.startPoint }}</span>
      </div>
    </ng-container>
  </div>
</div>
